import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
import { Checkbox, CheckboxItemType } from '../form';

export type RefineListSize = 'sm' | 'lg';

export type RefineListProps = {
  selectedOptions?: string[];
  handleSelect: (event: React.ChangeEvent<HTMLInputElement>) => void;
  options: CheckboxItemType[];
  size?: RefineListSize;
};

const RefineListWrapper = styled.div`
  max-height: 10000px;
  transition: max-height 0.2s; /* Transition the max-height property */
`;

const CheckboxWrapper = styled.div`
  font-family: ${theme.fonts.roboto};
  padding: ${theme.spacings[1].rem} 0;
`;

export const RefineList: React.FC<RefineListProps> = ({
  selectedOptions,
  options,
  handleSelect,
  size = 'sm',
}) => {
  return (
    <>
      <RefineListWrapper>
        {options.map((option) => (
          <CheckboxWrapper key={`${option.label} - ${selectedOptions?.length}`}>
            <Checkbox
              {...option}
              onChange={handleSelect}
              controlled={true}
              labelSize={size === 'sm' ? 'sm' : 'md'}
              checkboxSize={size === 'sm' ? 'sm' : 'lg'}
            />
          </CheckboxWrapper>
        ))}
      </RefineListWrapper>
    </>
  );
};
